import { useTheme } from '../../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';

export default function LegalPage() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${
      theme === 'dark' 
        ? 'bg-gradient-to-br from-[#0F0520] via-[#1A0B2E] to-[#2D1B4E]' 
        : 'bg-gradient-to-br from-gray-50 via-white to-purple-50'
    }`}>
      {/* Header */}
      <div className={`sticky top-0 z-10 backdrop-blur-xl border-b ${
        theme === 'dark' 
          ? 'bg-[#1A0B2E]/80 border-white/10' 
          : 'bg-white/80 border-gray-200'
      }`}>
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={() => navigate(-1)}
            className={`w-10 h-10 rounded-full transition-colors flex items-center justify-center ${
              theme === 'dark'
                ? 'bg-white/5 hover:bg-white/10'
                : 'bg-gray-100 hover:bg-gray-200'
            }`}
          >
            <i className={`ri-arrow-left-line text-xl ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}></i>
          </button>
          <h1 className={`text-xl font-semibold ${
            theme === 'dark' ? 'text-white' : 'text-gray-900'
          }`}>
            Información Legal
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 space-y-6 max-w-2xl mx-auto">
        {/* Términos de Servicio */}
        <section className={`p-6 rounded-2xl ${
          theme === 'dark'
            ? 'bg-white/5 backdrop-blur-sm'
            : 'bg-white shadow-sm'
        }`}>
          <div className="flex items-center gap-3 mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              theme === 'dark'
                ? 'bg-gradient-to-br from-purple-500/20 to-pink-500/20'
                : 'bg-gradient-to-br from-purple-100 to-pink-100'
            }`}>
              <i className="ri-file-text-line text-2xl text-purple-500"></i>
            </div>
            <h2 className={`text-lg font-semibold ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>
              Términos de Servicio
            </h2>
          </div>
          <div className={`space-y-3 text-sm leading-relaxed ${
            theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
          }`}>
            <p>
              Al utilizar esta aplicación, aceptas los siguientes términos y condiciones de uso.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                1. Uso del Servicio:
              </strong> Esta herramienta está diseñada para proporcionar cotizaciones estimadas de proyectos mediante inteligencia artificial. Las estimaciones son orientativas y pueden variar según las especificaciones finales del proyecto.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                2. Responsabilidad:
              </strong> No nos hacemos responsables de decisiones tomadas basándose únicamente en las cotizaciones generadas. Se recomienda consultar con profesionales antes de iniciar cualquier proyecto.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                3. Modificaciones:
              </strong> Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado del servicio implica la aceptación de los cambios.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                4. Propiedad Intelectual:
              </strong> Todo el contenido, diseño y funcionalidad de esta aplicación son propiedad de Paloma Studio y están protegidos por las leyes de propiedad intelectual.
            </p>
          </div>
        </section>

        {/* Política de Privacidad */}
        <section className={`p-6 rounded-2xl ${
          theme === 'dark'
            ? 'bg-white/5 backdrop-blur-sm'
            : 'bg-white shadow-sm'
        }`}>
          <div className="flex items-center gap-3 mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              theme === 'dark'
                ? 'bg-gradient-to-br from-blue-500/20 to-cyan-500/20'
                : 'bg-gradient-to-br from-blue-100 to-cyan-100'
            }`}>
              <i className="ri-shield-check-line text-2xl text-blue-500"></i>
            </div>
            <h2 className={`text-lg font-semibold ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>
              Política de Privacidad
            </h2>
          </div>
          <div className={`space-y-3 text-sm leading-relaxed ${
            theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
          }`}>
            <p>
              Tu privacidad es importante para nosotros. Esta política describe cómo recopilamos, usamos y protegemos tu información.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                1. Información Recopilada:
              </strong> Recopilamos únicamente la información necesaria para proporcionar el servicio de cotización, incluyendo detalles del proyecto que compartes durante la conversación.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                2. Uso de la Información:
              </strong> La información se utiliza exclusivamente para generar cotizaciones precisas y mejorar nuestro servicio. No compartimos tus datos con terceros sin tu consentimiento.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                3. Almacenamiento:
              </strong> Las conversaciones se almacenan de forma segura y pueden ser eliminadas en cualquier momento desde la configuración de la aplicación.
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                4. Cookies:
              </strong> Utilizamos cookies esenciales para el funcionamiento de la aplicación, como la preferencia de tema (claro/oscuro).
            </p>
            <p>
              <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                5. Tus Derechos:
              </strong> Tienes derecho a acceder, modificar o eliminar tu información en cualquier momento.
            </p>
          </div>
        </section>

        {/* Créditos */}
        <section className={`p-6 rounded-2xl ${
          theme === 'dark'
            ? 'bg-gradient-to-br from-purple-500/10 to-pink-500/10 backdrop-blur-sm border border-white/10'
            : 'bg-gradient-to-br from-purple-50 to-pink-50 shadow-sm'
        }`}>
          <div className="flex items-center gap-3 mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              theme === 'dark'
                ? 'bg-gradient-to-br from-pink-500/20 to-purple-500/20'
                : 'bg-gradient-to-br from-pink-100 to-purple-100'
            }`}>
              <i className="ri-sparkling-line text-2xl text-pink-500"></i>
            </div>
            <h2 className={`text-lg font-semibold ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>
              Créditos
            </h2>
          </div>
          <div className={`space-y-4 text-sm leading-relaxed ${
            theme === 'dark' ? 'text-gray-300' : 'text-gray-600'
          }`}>
            <div className="text-center py-4">
              <div className={`text-3xl font-bold mb-2 ${
                theme === 'dark'
                  ? 'bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent'
                  : 'bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent'
              }`} style={{ fontFamily: '"Pacifico", serif' }}>
                Paloma Studio
              </div>
              <p className={theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}>
                Diseño y Desarrollo
              </p>
            </div>
            <p className="text-center">
              Esta aplicación ha sido diseñada y desarrollada por <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>Paloma Studio</strong>, un estudio creativo especializado en experiencias digitales innovadoras.
            </p>
            <div className={`p-4 rounded-xl text-center ${
              theme === 'dark' ? 'bg-white/5' : 'bg-white'
            }`}>
              <p className="mb-2">
                <strong className={theme === 'dark' ? 'text-white' : 'text-gray-900'}>
                  Tecnologías utilizadas:
                </strong>
              </p>
              <p className={theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}>
                React • TypeScript • Tailwind CSS • Inteligencia Artificial
              </p>
            </div>
            <p className="text-center text-xs">
              © 2024 Paloma Studio. Todos los derechos reservados.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
